class MediaCredits {
  constructor() {
    this.credits = document.querySelectorAll('.js-media-credits');

    if (!this.credits.length) {
      return;
    }

    this.creditsToggle();
  }

  creditsToggle() {
    this.credits.forEach(credits => {
      credits
        .querySelector('.js-media-credits-button')
        .addEventListener('click', () => {
          credits.classList.toggle('show');
        });
    });
  }
}

export default new MediaCredits();



// WEBPACK FOOTER //
// ./src/scripts/modules/media-credits.js